(function () {
  var FORM_SELECTOR = '[data-dlarge-quote-form="true"]';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var SUCCESS_PARAM = 'quote_submitted';

  function setInput(form, selector, value) {
    var input = form.querySelector(selector);
    if (input) input.value = value || '';
  }

  function getVariantId() {
    var urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlVariant) return urlVariant;

    var selectedInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return selectedInput ? selectedInput.value : '';
  }

  function getVariants(form) {
    var container = form.closest('.dlarge-quote');
    var script = container && container.querySelector('[data-dlarge-product-variants]');
    if (!script) return [];

    try {
      return JSON.parse(script.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function updateVariantFields(form, variants) {
    var variantId = getVariantId();
    var variant = variants.find(function (item) {
      return String(item.id) === String(variantId);
    }) || variants[0];

    if (!variant) return;

    setInput(form, '[data-dlarge-variant-id]', variant.id);
    setInput(form, '[data-dlarge-variant-title]', variant.title);
    setInput(form, '[data-dlarge-variant-sku]', variant.sku);
  }

  function getPayload(form) {
    var payload = {};
    var data = new FormData(form);

    data.forEach(function (value, key) {
      var normalizedKey = key.replace(/^contact\[/, '').replace(/\]$/, '');
      payload[normalizedKey] = String(value || '');
    });

    payload.page_title = document.title || '';
    payload.submitted_at = new Date().toISOString();
    return payload;
  }

  function mirrorToSheets(form) {
    var endpoint = form.getAttribute('data-sheets-endpoint');
    if (!endpoint) return;

    var payload = JSON.stringify(getPayload(form));

    if (navigator.sendBeacon) {
      var blob = new Blob([payload], { type: 'text/plain;charset=UTF-8' });
      navigator.sendBeacon(endpoint, blob);
      return;
    }

    fetch(endpoint, {
      method: 'POST',
      mode: 'no-cors',
      keepalive: true,
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: payload
    }).catch(function () {});
  }

  function setSubmittingState(form) {
    var submit = form.querySelector('[data-dlarge-quote-submit]');
    if (!submit || submit.disabled) return;

    submit.setAttribute('aria-busy', 'true');
    submit.dataset.originalText = submit.textContent;
    submit.textContent = 'Изпращане...';
    submit.disabled = true;
    form.classList.add('is-submitting');
  }

  function showSuccessMessage(form) {
    var success = form.querySelector('[data-dlarge-quote-success]');
    if (!success) return;

    setQuotePanelExpanded(form, false, false);
    success.hidden = false;
    success.classList.remove('is-hidden');
    form.classList.add('is-submitted');

    window.setTimeout(function () {
      success.focus({ preventScroll: true });
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 120);
  }

  function setQuotePanelExpanded(form, expanded, focusFirstField) {
    var panel = form.querySelector('[data-dlarge-quote-panel]');
    var toggle = form.querySelector('[data-dlarge-quote-toggle]');
    if (!panel) return;

    panel.hidden = !expanded;
    panel.classList.toggle('is-hidden', !expanded);

    if (toggle) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded
        ? toggle.getAttribute('data-close-text') || 'Скрий формата'
        : toggle.getAttribute('data-open-text') || 'Направи запитване';
    }

    if (expanded && focusFirstField) {
      window.setTimeout(function () {
        var firstField = panel.querySelector('input:not([type="hidden"]):not([tabindex="-1"]), textarea, select');
        if (firstField) firstField.focus({ preventScroll: true });
      }, 80);
    }
  }

  function initQuoteToggle(form) {
    var toggle = form.querySelector('[data-dlarge-quote-toggle]');
    var panel = form.querySelector('[data-dlarge-quote-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var shouldExpand = panel.hidden;
      setQuotePanelExpanded(form, shouldExpand, shouldExpand);

      if (shouldExpand) {
        publishQuoteEvent('3dlarge:quote_button_clicked', form);
      }
    });
  }

  function publishQuoteEvent(eventName, form) {
    if (!window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) return;

    var payload = getPayload(form);
    delete payload.email;
    delete payload.phone;
    delete payload.name;
    delete payload.body;

    Shopify.analytics.publish(eventName, payload);
  }

  function fillTrackingFields(form) {
    var params = new URLSearchParams(window.location.search);

    setInput(form, '[data-dlarge-source-url]', window.location.href);
    setInput(form, '[data-dlarge-referrer]', document.referrer);
    setInput(
      form,
      '[data-dlarge-submission-id]',
      'quote-' + Date.now() + '-' + Math.random().toString(36).slice(2)
    );

    UTM_KEYS.forEach(function (key) {
      setInput(form, '[data-dlarge-' + key.replace('_', '-') + ']', params.get(key));
    });
  }

  function initForm(form) {
    var variants = getVariants(form);
    var params = new URLSearchParams(window.location.search);

    fillTrackingFields(form);
    updateVariantFields(form, variants);
    initQuoteToggle(form);

    if (params.get(SUCCESS_PARAM) === 'true') {
      showSuccessMessage(form);
      publishQuoteEvent('3dlarge:quote_request_confirmed', form);
    }

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('form[action*="/cart/add"] [name="id"]')) {
        updateVariantFields(form, variants);
      }
    });

    form.addEventListener('submit', function () {
      updateVariantFields(form, variants);
      setSubmittingState(form);
      mirrorToSheets(form);
      publishQuoteEvent('3dlarge:quote_request_submitted', form);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(FORM_SELECTOR).forEach(initForm);
  });
})();
